import { render, staticRenderFns } from "./WanatelPbxService.vue?vue&type=template&id=49397c3a&"
import script from "./WanatelPbxService.vue?vue&type=script&lang=js&"
export * from "./WanatelPbxService.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports